import { MapperFrequencyMode, MapperPolicyRecurrence } from 'app/model/adfDataMapper/mapperPolicyRecurrence';
import { IModel, Metamodel, Named } from 'shell-models-lib';

@Metamodel.model({
    name: 'MapperPolicy'
})
export class MapperPolicy extends Named {
    public static readonly MODEL: IModel;
    public recurrence: MapperPolicyRecurrence;
    public mode: MapperFrequencyMode;
    constructor(recurrence?: MapperPolicyRecurrence, mode?: MapperFrequencyMode){
        super();
        this.recurrence = recurrence;
        this.mode = mode;
    }
}
